import { render } from "./RelatorioTermometria.vue?vue&type=template&id=3f1b1725&scoped=true"
import script from "./RelatorioTermometria.vue?vue&type=script&lang=js"
export * from "./RelatorioTermometria.vue?vue&type=script&lang=js"

import "./RelatorioTermometria.vue?vue&type=style&index=0&id=3f1b1725&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1b1725"]])

export default __exports__